import { z } from 'zod';

export const ApplyKitSlotSelectionSchema = z.object({
  categoryId: z.uuid(),
  itemType: z.enum(['PRODUCT', 'SERVICE']),
  itemId: z.uuid(),
  /** Catalog unit price in cents — used for base subtotal before weight rateio + kit adjustment. */
  unitPriceCents: z.string().regex(/^\d+$/).optional(),
});

export const ApplyKitSlotBodySchema = z.object({
  kitId: z.uuid(),
  selections: z.array(ApplyKitSlotSelectionSchema).min(1),
  vehicleModelId: z.uuid().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  placeId: z.uuid().optional(),
  assignedMechanicUserId: z.uuid().optional(),
});

export const ApplyKitSlotResponseSchema = z.object({
  addedItemIds: z.array(z.uuid()),
});

export type ApplyKitSlotSelection = z.infer<typeof ApplyKitSlotSelectionSchema>;
export type ApplyKitSlotBody = z.infer<typeof ApplyKitSlotBodySchema>;
export type ApplyKitSlotResponse = z.infer<typeof ApplyKitSlotResponseSchema>;
